export const GET_MERCHANT_PAYMENT_DETAIL_BY_TRANSACTION_PROVISION_SETTLE_GUID= "GET_MERCHANT_PAYMENT_DETAIL_BY_TRANSACTION_PROVISION_SETTLE_GUID"
export const GET_MERCHANT_PAYMENT_DETAIL_BY_TRANSACTION_PROVISION_SETTLE_GUID_SUCCESS = "GET_MERCHANT_PAYMENT_DETAIL_BY_TRANSACTION_PROVISION_SETTLE_GUID_SUCCESS"
export const GET_MERCHANT_PAYMENT_DETAIL_BY_TRANSACTION_PROVISION_SETTLE_GUID_FAIL = "GET_MERCHANT_PAYMENT_DETAIL_BY_TRANSACTION_PROVISION_SETTLE_GUID_FAIL"

export const MERCHANT_PAYMENT_DETAIL_API_ERROR = "API_ERROR"
